"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.personalEditorialArticlePageFragment = void 0;
var _fetching = require("@ori/fetching");
var _editorialArticlePageFragment = require("./editorialArticlePageFragment");
const personalEditorialArticlePageFragment = exports.personalEditorialArticlePageFragment = (0, _fetching.gql)`
  fragment PersonalEditorialArticlePage on Application {
    personalEditorialPage(pageId: $pageId) {
      pageId
      contentItems {
        ...EditorialContent
      }
    }
  }
  ${_editorialArticlePageFragment.editorialContentTypesFragment}
`;
